/*=========================================================================================
  File Name: module-mws.js
  Description: MWS Module — token cache cho kết nối MISA WebSocket Service
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-mws-state';
import mutations from './module-mws-mutations';
import actions from './module-mws-actions';
import getters from './module-mws-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
